var Markers = (function () {

    'use strict';

    class MarkerResource{
        constructor(type, url)
        {
            this.type = type;
            this.url = url;
        }
    }

    class MarkerParameters {
        constructor(width, height){
            this.width = width;
            this.height = height;
        }
    }

    class Marker {
        constructor(id, name, fileName, resources, parameters) {
            this.id = id;
            this.name = name;
            this.fileName = fileName;
            this.resources = resources;
            this.parameters = parameters;
        }
    
    
    }

    //
    // Variables
    //

    var publicAPIs = {};

    let endpoint = "https://5bd73f9ea6871d00133234b7.mockapi.io/api/";
    let parameters = {};

    //
    // Methods
    //

	/**
	 * A private method
	 */
    var somePrivateMethod = function () {
        // Code goes here...
    };

    publicAPIs.loadParameters = (callback) => {
        console.log('loading parameters');
        fetch(endpoint + 'settings').then((response)=>{
            response.json().then(json=>{
                parameters = json;
                callback(parameters);
            })
        }).catch((e)=>{
            console.error(e);
        });
    }

	/**
	 * A public method
	 */
    publicAPIs.loadMarkers = function (callback) {
        console.log("Loading markers");
        fetch(endpoint + 'markers').then((response) => {           
            response.json().then(json => {
                let data = json;
                let ret = [];
                data.forEach(element => {
                    var resources = [];
                    element.resources.forEach(res => {
                        resources.push(new MarkerResource(res.type, res.url));
                    });
                    
                    var parameters = new MarkerParameters();

                    var m = new Marker(element.id, element.name, element.fileName, resources, parameters);
                    ret.push(m);
                });
                callback(ret);
            });
        }).catch(function() {
            console.log("error");
        });
    ;
    };

	/**
	 * Another public method
	 */
    publicAPIs.init = function (options) {
        options = options || {};
        endpoint = options.endpoint || endpoint;
    };


    //
    // Return the Public APIs
    //

    return publicAPIs;

});

export default Markers;